<template>
    <div class="m-auto text-center">
        <h3 style="margin-top:64px">{{message}}</h3>
    </div>
</template>
<script>
import { DataApi } from "../../../service/DataApi";
export default {
    
    data() {
        return {
            message: 'Maaf, anda tidak berhak melihat Data.',
        }
    },
    methods: {
        getFile() {
            let tipe = this.$route.params.tipe
            let base = ''
            let names = ''
            let payload = {
                bulan: this.$route.params.month,
                idKontrakPengadaan: this.$route.params.id,
                tahun: this.$route.params.year
            }
            if(tipe == '1') {
                base = '/export/kontrak_pengadaan/bauk_po'
                names = 'Data BAUK PO '
            } else {
                base = '/export/kontrak_pengadaan/bauk_non_po'
                names = 'Data BAUK NON PO '
            }
            
            DataApi.post(base, payload , {responseType: 'blob'})
            .then(res => {
                let response = res.data
                this.message = 'Data Berhasil di Lihat'
                // let fileName = res.headers["content-disposition"].split("filename=")[1];
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/vnd.ms-excel'
                }))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', names + this.$route.params.month + '/' + this.$route.params.year)
                document.body.appendChild(link)
                link.click()
            })
        },
        goHome() {
            setTimeout(this.$router.replace("/pages/login"), 3000);
        },
    },
    mounted() {
        if(localStorage.getItem("token")) {
            this.getFile()
        } else {
            this.goHome()
        }
    }
}
</script>